import * as R from 'ramda'
import { DateTarget, NumericTarget, StringTarget } from '../services/Model/Addendum'

function getTopLevelTargets(target: StringTarget | DateTarget | NumericTarget): boolean{
	return target.targetType === 'COMPLETED' || target.targetType === 'ENROLLED' || target.targetType === 'PLACED'
}

export const createTargetsMapper =
	(targets: Array<StringTarget | DateTarget | NumericTarget>): { [key: string]: any }=> {
	const [topLevelTargets] = R.partition(getTopLevelTargets, targets)
	const obj = {topLevelTargets}

	return obj
}
